import moment from "moment/moment";

/** Логика перенесена из старого Distancer.Core
 * */
export class EstimatedTimeOfArrivalCalculator {
  /** @type {moment.Duration} */
  #zeroDuration;
  /** @type {number} */
  #zeroDistance;
  /** @type {number} */
  #tolerance;

  constructor(calculations) {
    this.dailyMileage = calculations.dailyMileage;
    this.workDayStartTime = moment.duration(9, 'hour');
    this.workingDayDuration = moment.duration(calculations.workingDay, 'hour');
    this.departureDate = moment(calculations.departureDate);
    this.departureTime = moment.duration({
      hours: calculations.departureHour,
      minutes: calculations.departureMinute
    });
    /** @private */
    this.#zeroDuration = moment.duration();
    this.#zeroDistance = 0;
    this.#tolerance = 0.0000000000001;
  }

  /** @param {Object} counters
   * @param {moment.Moment} counters.currentDate
   * @param {moment.Duration} counters.currentTime
   * @param {number} counters.distBalance
   * @param {moment.Duration} counters.timeBalance
   * @private
   */
  #incrementWorkday(counters) {
    counters.currentDate.add(1, 'day');
    counters.currentTime = this.workDayStartTime;
    counters.distBalance = this.dailyMileage;
    counters.timeBalance = this.workingDayDuration;
  }

  calculate(routeSegments) {

    let timeDiff = moment.duration(this.departureTime - this.workDayStartTime);
    if (timeDiff < this.#zeroDuration)
      timeDiff = this.#zeroDuration;

    const counters = {
      /** @type {moment.Moment} */
      currentDate: this.departureDate.clone(),
      /** @type {moment.Duration} */
      currentTime: this.departureTime.clone(),
      /** @type {number} */
      distBalance: this.dailyMileage,
      /** @type {moment.Duration} */
      timeBalance: moment.duration(this.workingDayDuration - timeDiff)
    };

    if (counters.timeBalance < this.#zeroDuration) {
      this.#incrementWorkday(counters);
    }

    routeSegments[0].estimatedTimeOfArrival = this.departureDate.clone().add(this.departureTime);
    for (let i = 0; i < routeSegments.length - 1; i++) {
      const currentSegment = routeSegments[i];
      const nextSegment = routeSegments[i + 1];

      nextSegment.estimatedTimeOfArrival = this.#calculateForSegment(counters, moment.duration(currentSegment.segmentDurationHours, 'hour'), currentSegment.segmentDistance);
    }
  }

  /** @param {Object} counters
   * @param {moment.Moment} counters.currentDate
   * @param {moment.Duration} counters.currentTime
   * @param {number} counters.distBalance
   * @param {moment.Duration} counters.timeBalance
   * @param {moment.Duration} timeToNext
   * @param {number} distanceToNext
   */
  #calculateForSegment(counters, timeToNext, distanceToNext) {
    while (true) {
      counters.timeBalance = moment.duration(counters.timeBalance - timeToNext);
      counters.distBalance -= distanceToNext;
      const arrivedAtTheNextSegment = counters.timeBalance >= this.#zeroDuration && counters.distBalance >= this.#zeroDistance;
      if (arrivedAtTheNextSegment) {
        counters.currentTime = moment.duration(counters.currentTime + timeToNext);
        const result = counters.currentDate.clone().add(counters.currentTime);

        if (counters.timeBalance === this.#zeroDuration || Math.abs(counters.distBalance - this.#zeroDistance) < this.#tolerance) {
          this.#incrementWorkday(counters);
        }
        return result;
      }
      const workingTimeLimitExceeded = counters.timeBalance < this.#zeroDuration && counters.distBalance >= this.#zeroDistance;
      if (workingTimeLimitExceeded) {
        distanceToNext = moment.duration(-counters.timeBalance) / timeToNext * distanceToNext;
        timeToNext = moment.duration(-counters.timeBalance);
        this.#incrementWorkday(counters);
      }
      const dailyMileageLimitExceeded = counters.timeBalance >= this.#zeroDuration && counters.distBalance < this.#zeroDistance;
      if (dailyMileageLimitExceeded) {
        timeToNext = moment.duration(-counters.distBalance / distanceToNext * timeToNext);
        distanceToNext = -counters.distBalance;
        this.#incrementWorkday(counters);
      }
      const timeAndMileageLimitsExceeded = counters.timeBalance < this.#zeroDuration && counters.distBalance < this.#zeroDistance;
      if (timeAndMileageLimitsExceeded) {
        const dailyDistanceWithoutOverhead = distanceToNext + counters.distBalance;
        const timeToDistanceOverhead = moment.duration(dailyDistanceWithoutOverhead / distanceToNext * timeToNext);
        const mileageLimitExceededEarlier = timeToDistanceOverhead < moment.duration(counters.timeBalance + timeToNext);
        if (mileageLimitExceededEarlier) {
          distanceToNext = -counters.distBalance;
          timeToNext = moment.duration(timeToNext - timeToDistanceOverhead);
        }
        //ограничение по времени превышается раньше
        else {
          distanceToNext -= moment.duration(timeToNext + counters.timeBalance) / timeToNext * distanceToNext; //WTF
          timeToNext = moment.duration(-counters.timeBalance);
        }
        this.#incrementWorkday(counters);
      }
    }
  }
}